module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiExt.749af2c.eot";